<template>
    <section class="pt-32 overflow-hidden">
        <div class="mb-32 flex">
            <div class="mr-48 w-1/3">
                <h1 class="first-letter:uppercase text-body font-semibold text-black mb-4">{{ title }}</h1>
                <p class="text-black">{{ description }}</p>
            </div>
            <div class="w-2/3 shadow-sm bg-white rounded pt-24 pl-24">
                <div class="mb-24 mr-24">
                    <div class="max-w-480">
                        <slot></slot>
                    </div>
                    <div class="pt-24">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        title: String,
        description: String,
    }
}
</script>
